import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Icon from "@mdi/react";
import { mdiClose, mdiDelete } from "@mdi/js";
import { pushNotification } from "utils/notifications";
import { getBranch } from "utils/utils";
export const ModalDanhGia = ({ toggleModal, item }) => {
  const dispatch = useDispatch();
  const addDanhGia = () => {
    window.location.href = "/Ticket/DanhGia?idTicket=" + item.idTicket;
  };
  return (
    <>
      <div className="popup ">
        <div class="popup_inner " style={{ maxWidth: "500px" }}>
          <div class="modal-content form-modal-new modal-new-ticket">
            <div class="modal-header ">
              <button
                type="button"
                class="close"
                onClick={toggleModal}
                aria-label="Close"
              >
                <Icon path={mdiClose} title="In" size={1.5} color="#ccc" />
              </button>
            </div>
            <div class="modal-body text-center-main">
              <span className="title-ticket">Đánh giá Ticket</span>
              <br />
              <span className="body-ticket">
                {item.TieuDeTicket}: đã <b>{item.TenTrangThaiTicket}</b>
              </span>
              <br />
              <span>
                Vui lòng đánh giá hỗ trợ, đánh giá của bạn sẽ giúp chúng tôi
                hoàn thiện phần mềm tốt hơn.
              </span>
            </div>
            <div class="modal-footer">
              <div class="footer-search-main">
                <div className="row-50">
                  <a
                    href={() => false}
                    class="text-button-new text-close"
                    onClick={toggleModal}
                  >
                    Để sau
                  </a>
                </div>
                <div className="row-50">
                  <a
                    href={() => false}
                    onClick={(e) => addDanhGia()}
                    class="text-button-new text-ticket"
                  >
                    Đánh giá ngay
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
